import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-todo",
  "use": "icon-todo-usage",
  "viewBox": "0 0 1034 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1034 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-todo\"><defs><style type=\"text/css\"></style></defs><path d=\"M302.638545 932.677818v-93.090909h709.02691v93.090909z m0-297.472v-93.090909h709.02691v93.090909z m-256-291.467636L115.432727 281.041455l98.071273 107.706181 261.678545-295.610181 69.818182 61.672727-330.472727 373.201454z m592.663273-6.050909v-93.090909h372.363637v93.090909z\" p-id=\"2051\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol